import { Component, Input, OnInit, ViewChild, input } from "@angular/core";
import { RobotRulesService, EditMode, TaskEventType, TaskType } from "../robot-rules.service";
import _ from "lodash";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { TranslateService } from "@root/shared/service/translate.service";
import { AppService } from "@root/app.service";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "host-task-rules",
  templateUrl: "./task-rules.component.html",
  styleUrls: ["./task-rules.component.scss"],
})
export class TaskRulesComponent implements OnInit {
  private readonly StaffListApi = "/api/schedule/staff/list";
  @ViewChild("textarea", { static: true }) textarea;
  readonly EventType: typeof TaskEventType = TaskEventType;
  private readonly defaultScopeHouses = [-1];
  @Input() editMode: EditMode = EditMode.Create;
  @Input() event: TaskEventType = TaskEventType.Checkin; // 暂时不可更改
  @Input() id;
  @Input() subevent = "before_checkout"; // 暂时只有一个，且不可改

  @Input()
  set taskType(value: TaskType) {
    this.actionTaskForm.patchValue({ task_type: value });
  }

  optionsOfCleander: Option[] = [];
  actionTaskForm: UntypedFormGroup = this.fb.group({
    task_type: this.taskType, // 暂时只有一个，遗留问题，写死，不可改
    duration_minute: 30, // 遗留问题，写死，不可改
    assigned_person: null,
    description: null,
    check_list: [[]],
  });

  scopeHouses = {
    type: "none",
    value: this.defaultScopeHouses,
  };

  //#region 4.10新加的time
  optionsOfTriggerType = [
    { label: this.t.t("automation-task-rules_html_type_opt_checkout"), value: "checkout" },
    { label: this.t.t("automation-task-rules_html_type_opt_checkin"), value: "checkin" },
  ];
  optionsOfCheckinOffsetDay = [
    { label: this.t.t("automation-task-rules_html_offset_checkin_opt_1"), value: 1 },
    { label: this.t.t("automation-task-rules_html_offset_checkin_opt_0"), value: 0 },
  ];
  optionsOfCheckoutOffsetDay = [
    { label: this.t.t("automation-task-rules_html_offset_checkout_opt_0"), value: 0 },
    { label: this.t.t("automation-task-rules_html_offset_checkout_opt_1"), value: 1 },
  ];
  triggerType: "checkin" | "checkout" = "checkout";
  offsetDays = 0;
  //#region
  @Input() listOfDynContentOption = [];

  get isInternational() {
    return this.app.app.international;
    // return this.international.isInternational();
  }

  get checkList() {
    return this.actionTaskForm.get("check_list").value;
  }
  constructor(
    private robotSrv: RobotRulesService,
    private messageService: NzMessageService,
    // private modalService: NzModalService,
    private modalRef: NzModalRef,
    // private international: InternationalService,
    private app: AppService,
    private t: TranslateService,
    private fb: UntypedFormBuilder,
    private http: HttpClient,
  ) {}

  ngOnInit() {
    this.fetchOptionsOfCleaner();
    if (this.editMode === EditMode.Update || this.editMode === EditMode.Copy) {
      this.fetchRuleDetail();
    }
    // this.subscribeScopeFormChange();
  }

  private fetchOptionsOfCleaner() {
    const params = { page: 1, page_size: 1000 };
    this.http.get(this.StaffListApi, { params }).subscribe((rst: any) => {
      this.optionsOfCleander = (rst.data.list || []).map((staff) => ({
        label: staff.name,
        value: staff.id,
      }));
    });
  }

  fetchRuleDetail() {
    this.robotSrv.fetchTaskRuleDetail({ id: this.id }).subscribe((res) => {
      const record = _.get(res, "data.record") || {};
      const { id, action, event, scope } = record;
      this.id = id;
      this.convertFromActionParams(action);
      this.convertFromEventParams(event);
      this.convertFromScopeParams(scope);
    });
  }

  requestSaveRobotRules() {
    const status = 1;
    const event = this.convertToEventParams();
    const action = this.convertToActionParams();
    const scope = this.convertToScopeParams();

    const params = { status, event, action, scope };

    if (this.editMode === EditMode.Update) {
      /** 新建和复制都不传id */
      _.assign(params, { id: this.id });
    }

    this.robotSrv.updateTaskRobotRules(params).subscribe((res) => {
      console.log("res: ", res);
      if (res.error_code === 0) {
        this.messageService.success(this.t.syncGet("word.success"));

        this.close();
      }
    });
  }

  onSelectDynContent(content) {
    const desc = this.actionTaskForm.value.description;
    const value = desc || "";
    const pos = this.textarea.nativeElement.selectionStart;

    this.actionTaskForm.patchValue({
      description: value.slice(0, pos) + `{{${content}}}` + value.slice(pos),
    });
  }

  //#region Check list

  onAddCheckList() {
    this.checkList.push({ title: "", status: 0 });
  }

  onRemoveCheckList(index) {
    this.checkList.splice(index, 1);
  }

  //#endregion

  onSave() {
    this.requestSaveRobotRules();
  }

  onCancel() {
    this.close();
  }

  private convertToEventParams() {
    const event = {
      event_type: this.event,
      sub_event_type: this.subevent,
    };
    return event;
  }

  private convertToActionParams() {
    // const node = this.nodeType;
    const value = this.actionTaskForm.value;

    const action = {
      task: {
        ...value,
        trigger_type: this.triggerType,
        offset_days: this.offsetDays,
        // assigned_person: value.assigned_person?.[0],
      },
    };
    return action;
  }

  private convertToScopeParams() {
    const result = {};
    const { type, value } = this.scopeHouses;
    const scopeHouses = this.getOrDefault(value, this.defaultScopeHouses);

    if (type === "none") {
      Object.assign(result, { property_any: [-1] });
    } else if (type === "house") {
      Object.assign(result, { house: scopeHouses });
    } else if (type === "group") {
      Object.assign(result, { group: scopeHouses });
    } else {
      Object.assign(result, { room_type: scopeHouses });
    }
    return result;
  }

  private convertFromEventParams(params) {
    this.event = params.event_type;
    this.subevent = params.sub_event_type;
  }

  private convertFromActionParams(params) {
    const task = params.task || {};
    this.actionTaskForm.patchValue({
      ...task,
    });
    this.triggerType = task.trigger_type || "checkout";
    this.offsetDays = task.offset_days || 0;
  }

  private convertFromScopeParams(params) {
    if (params.group) {
      this.scopeHouses = {
        type: "group",
        value: params.group,
      };
    } else if (params.room_type) {
      this.scopeHouses = {
        type: "room_type",
        value: params.room_type,
      };
    } else {
      if (params.house?.[0] === -1 || params.property_any?.[0] === -1) {
        this.scopeHouses = {
          type: "none",
          value: [-1],
        };
      } else {
        this.scopeHouses = {
          type: "house",
          value: params.house,
        };
      }
    }
  }

  private getOrDefault(value: any[], defaults) {
    if (_.isEmpty(value)) {
      return defaults;
    }
    return value;
  }

  private close() {
    this.modalRef.close();
  }
}
